import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import * as api from "../../api/timeOff";

const STATE_COLOR = {
  pending: "text-amber-500", approved: "text-emerald-500", rejected: "text-rose-500",
  cancelled: "text-muted-foreground", cancel_requested: "text-cyan-500", completed: "text-violet-500",
};

// قائمة طلبات الإجازة الزمنية للموظف مع أزرار الإلغاء وتسجيل العودة.
export const TimeOffList = ({ reloadToken }) => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  const load = async () => setItems(await api.listMine());
  useEffect(() => { load(); }, [reloadToken]);

  const cancel = async (id, endTime) => {
    const now = new Date(); const [h, m] = (endTime || "23:59").split(":").map(Number);
    const end = new Date(); end.setHours(h, m, 0, 0);
    const minutesLeft = (end - now) / 60000;
    try {
      if (minutesLeft >= 60) await api.requestCancel(id);
      else await api.submitCancelRequest(id);
      toast.success(t("timeOff.cancelDone"));
      load();
    } catch (err) {
      const code = err?.response?.data?.detail?.code || "TIME_OFF_GENERIC";
      toast.error(t(`timeOff.errors.${code}`, { defaultValue: t("errors.generic") }));
    }
  };

  const recordReturn = async (id) => {
    try { await api.recordReturn(id); toast.success(t("timeOff.returnRecorded")); load(); }
    catch { toast.error(t("errors.generic")); }
  };

  if (!items.length) return <p className="text-sm text-muted-foreground">{t("myRequests.emptyLeaves")}</p>;
  return (
    <ul className="grid gap-3" data-testid="time-off-list">
      {items.map((it) => (
        <li key={it.id} className="rounded-3xl bg-background p-4 shadow-neu-sm" data-testid={`time-off-row-${it.id}`}>
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="text-sm font-bold">{t(`timeOff.type.${it.time_off_type}`)} · {it.hours}h</p>
              <p className="text-xs text-muted-foreground">{it.request_date} · {it.start_time || "—"} → {it.end_time || "—"}</p>
              <p className="mt-1 font-mono text-[11px] text-muted-foreground">{it.ref_no}</p>
            </div>
            <span className={`text-xs font-black ${STATE_COLOR[it.status] || ""}`}>{t(`timeOff.status.${it.status}`)}</span>
          </div>
          <div className="mt-2 flex flex-wrap gap-2">
            {["pending", "approved"].includes(it.status) ? (
              <NeuButton type="button" className="px-3 py-1.5 text-xs" data-testid={`time-off-cancel-${it.id}`}
                         onClick={() => cancel(it.id, it.end_time)}>{t("timeOff.cancel")}</NeuButton>
            ) : null}
            {it.status === "approved" && it.time_off_type === "mid_day" ? (
              <NeuButton type="button" variant="primary" className="px-3 py-1.5 text-xs" data-testid={`time-off-return-${it.id}`}
                         onClick={() => recordReturn(it.id)}>{t("timeOff.recordReturn")}</NeuButton>
            ) : null}
            {it.return_status ? (
              <span className="text-[11px] font-bold text-muted-foreground">
                {t(`timeOff.returnStatus.${it.return_status}`)}
              </span>
            ) : null}
          </div>
        </li>
      ))}
    </ul>
  );
};
